import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'

import ComorbidityModal from '@components/modal/comorbidityModal'
import SpreadSheetModal from '@components/modal/spreadSheetModal'
import MessageSenderModal from '@components/modal/messageSenderModal'
import CheckBox from '@components/inputs/checkBox'

import { WindowContext } from '@components/windowContextProvider'

import 'material-icons/iconfont/outlined.css'

import {
  Container,
  SearchContainer,
  FeatureContainer,
  CheckBoxContainer,
  SearchIcon,
  FileDownloadOutlinedIcon,
  TuneIcon,
  Button,
  Input,
  Row,
  ForwardToInboxIcon
} from './styles'

const BeneficiaryFilter = ({
  filterState,
  selectAllState,
  setFilterState,
  searchTerm,
  onSearch,
  onInputChange,
  onSelectAllChange,
  selectedBeneficiaries,
  labelText,
  filteredBeneficiaries,
  companyId,
  programmeId,
}) => {
  const [comorbidityModal, setComorbidityModal] = useState(false)
  const [spreadSheetModal, setSpreadSheetModal] = useState(false)
  const [messageSenderModal, setMessageSenderModal] = useState(false)
  const { clientWidth } = useContext(WindowContext)

  const handleSelectAllStateChange = (e) => {
    onSelectAllChange(e)
  }

  const selectAllBreak = clientWidth <= 845

  const inputBreak = clientWidth <= 490

  const inputPlaceHolderBreak = clientWidth <= 390

  const renderCheckBoxContainer = (
    <CheckBoxContainer state={selectAllState}>
      <CheckBox
        checked={selectAllState}
        onChange={(e) => handleSelectAllStateChange(e)}
        label={labelText}
        state={selectAllState}
      />
    </CheckBoxContainer>
  )

  const renderFeatures = (
    <FeatureContainer>
      <Button
        onClick={() => setComorbidityModal(true)}
      >
        <TuneIcon className="material-icons-outlined" state={selectAllState}>tune</TuneIcon>
      </Button>
      <ForwardToInboxIcon
        className="material-icons-outlined"
        state={selectAllState}
        onClick={() => setMessageSenderModal(true)}
      >
        forward_to_inbox
      </ForwardToInboxIcon>
      <FileDownloadOutlinedIcon
        className="material-icons-outlined"
        state={selectAllState}
        onClick={() => setSpreadSheetModal(true)}
      >
        file_download
      </FileDownloadOutlinedIcon>
    </FeatureContainer>
  )

  return (
    <Container state={selectAllState}>
      <Row>
        {!selectAllBreak && renderCheckBoxContainer}
        <SearchContainer>
          <Input
            placeholder="Digite parte do nome ou do CPF"
            value={searchTerm}
            style={{
              fontSize: inputPlaceHolderBreak ? 12 : 14
            }}
            onChange={(e) => onInputChange(e)}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
          />
          <Button onClick={onSearch}>
            <SearchIcon className="material-icons-outlined" state={selectAllState}>search</SearchIcon>
          </Button>
        </SearchContainer>

        {!inputBreak && renderFeatures}

        <ComorbidityModal
          filterState={filterState}
          setFilterState={setFilterState}
          isOpen={comorbidityModal}
          setClose={() => setComorbidityModal(false)}
        />

        <MessageSenderModal
          filterState={filterState}
          setFilterState={setFilterState}
          isOpen={messageSenderModal}
          selectedBeneficiaries={selectedBeneficiaries}
          setClose={() => setMessageSenderModal(false)}
        />

        <SpreadSheetModal
          isOpen={spreadSheetModal}
          setClose={() => setSpreadSheetModal(false)}
          filteredBeneficiaries={filteredBeneficiaries}
          selectedBeneficiaries={selectedBeneficiaries}
          filterState={filterState}
          searchTerm={searchTerm}
          companyId={companyId}
          programmeId={programmeId}
        />
      </Row>
      {selectAllBreak && (
        <Row>
          {renderCheckBoxContainer}
          {inputBreak && renderFeatures}
        </Row>
      )}
    </Container>
  )
}

BeneficiaryFilter.propTypes = {
  selectAllState: PropTypes.bool,
  filterState: PropTypes.shape({
    noRisk: PropTypes.bool,
    highRisk: PropTypes.bool,
    mediumRisk: PropTypes.bool,
    lowRisk: PropTypes.bool,
    diabetic: PropTypes.bool,
    hypertensive: PropTypes.bool,
    overweight: PropTypes.bool,
    dyslipidemic: PropTypes.bool,
    searchTerm: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  searchTerm: PropTypes.string,
  onSelectAllChange: PropTypes.func,
  selectedBeneficiaries: PropTypes.array,
  labelText: PropTypes.string,
  setFilterState: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  filteredBeneficiaries: PropTypes.array,
  companyId: PropTypes.number,
  programmeId: PropTypes.number,
}

BeneficiaryFilter.defaultProps = {
  selectAllState: null,
  searchTerm: '',
  filterState: {},
  onSelectAllChange: {},
  selectedBeneficiaries: [],
  labelText: '',
  filteredBeneficiaries: [],
  companyId: undefined,
  programmeId: undefined,
}

export default BeneficiaryFilter
